import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


export default function VehicleOwnerTooltip({ vehicle, className = '' }) {
  const navigate = useNavigate();
  const ownerName = vehicle?.owner_name;

  if (!ownerName) {
    return <span className={`text-gray-400 ${className}`}>—</span>;
  }

  const lines = [
    vehicle.vehicle_owner_id && { label: 'Owner ID', value: vehicle.vehicle_owner_id },
    vehicle.owner_contact && { label: 'Contact', value: vehicle.owner_contact },
    vehicle.owner_email && { label: 'Email', value: vehicle.owner_email },
    vehicle.owner_gst && { label: 'GST', value: vehicle.owner_gst },
    vehicle.owner_percentage != null &&
      vehicle.owner_percentage !== '' && {
        label: 'Commission %',
        value: `${vehicle.owner_percentage}%`,
      },
  ].filter(Boolean);

  const handleOwnerClick = (e) => {
    e.stopPropagation();
    if (vehicle?.vehicle_owner_id != null) {
      navigate(`/vehicle-owners/view/${vehicle.vehicle_owner_id}`);
    }
  };

  return (
    <span className={`relative inline-block max-w-full group ${className}`}>
      <button
        type="button"
        onClick={handleOwnerClick}
        className="truncate block w-full text-left text-gray-700 font-medium cursor-pointer hover:text-buttonhoverTxt hover:underline border-b border-dotted border-gray-400"
      >
        {ownerName}
      </button>
      <span
        role="tooltip"
        className="pointer-events-none absolute bottom-full left-0 z-[60] mb-2 hidden min-w-[12rem] max-w-xs rounded-lg border border-gray-700 bg-gray-900 px-3 py-2.5 text-left text-xs text-white shadow-xl group-hover:block"
      >
        <span className="block font-semibold text-orange-200 mb-1.5">{ownerName}</span>
        {lines.length > 0 ? (
          <span className="flex flex-col gap-1">
            {lines.map((line) => (
              <span key={line.label} className="flex gap-2">
                <span className="text-gray-400 shrink-0">{line.label}:</span>
                <span className="break-all">{line.value}</span>
              </span>
            ))}
          </span>
        ) : (
          <span className="text-gray-400">No additional details</span>
        )}
      </span>
    </span>
  );
}
